/**
 * Reports API service
 */

import apiClient from './api';

export interface ReportInfo {
  report_id: string;
  report_type: string;
  agent_id?: string;
  generated_at: string;
  status: string;
}

export interface ReportContent {
  report_id: string;
  content: string;
  agent_name?: string;
  generated_at: string;
}

export const reportService = {
  /**
   * Generate reports for a session
   */
  async generateReports(sessionId: string): Promise<any> {
    const response = await apiClient.post(`/api/sessions/${sessionId}/reports/generate`);
    return response.data;
  },

  /**
   * Get list of reports
   */
  async listReports(sessionId: string): Promise<{ reports: ReportInfo[] }> {
    const response = await apiClient.get(`/api/sessions/${sessionId}/reports`);
    return response.data;
  },

  /**
   * Get report content
   */
  async getReport(sessionId: string, reportId: string): Promise<ReportContent> {
    const response = await apiClient.get(`/api/sessions/${sessionId}/reports/${reportId}`);
    return response.data;
  },

  /**
   * Download single report
   */
  getDownloadUrl(sessionId: string, reportId: string): string {
    return `${apiClient.defaults.baseURL}/api/sessions/${sessionId}/reports/${reportId}/download`;
  },

  /**
   * Download all reports as ZIP
   */
  getDownloadAllUrl(sessionId: string): string {
    return `${apiClient.defaults.baseURL}/api/sessions/${sessionId}/reports/download-all`;
  },
};

export default reportService;
